import React, { useMemo,useRef, useState, useEffect } from "react";
import { useMutation } from "react-query";
import { TitleComponent } from "ui-components";
import {
  companiesMutation,
  CompanyResultT,
} from "ui-io/queries/get-filtered-companies";
import useLocalStorage from "ui-io/use-local-storage";
import FilterComponent from "./filter";
import Company from "../company";
import { FilterT, filterArray, FilterTArrayCodec } from "./constants";

const LOCAL_STORAGE_KEY = "saved_filters";
type Props = {
  showFilter?: boolean;
};

const FundingRounds = ({ showFilter = true }: Props) => {
  const hasFetched = useRef(false);

  const [companyData, setCompanyData] = useState<CompanyResultT>();
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [isBasicFilterOpen, setBasicFilterIsOpen] = useState(false);
  //  const [filters, setFilters] = useLocalStorage<FilterT[]>(
  //     LOCAL_STORAGE_KEY,
  //     filterArray.filter((filter) => filter?.isSelected),
  //     FilterTArrayCodec
  //   );

  const companyMutation = useMutation(companiesMutation, {
    onSuccess: (response: CompanyResultT) => {
      if (setCompanyData) setCompanyData(response);
    },
    onError: () => {},
  });
  const handleFilterSearch = (filters: FilterT[]) => {
    setCurrentPage(0); // Reset page to 0
    handleSearchRequest(filters, 0);
  };
  const handleCurrentPageChange = (page: number = 0, isInitial:boolean = false) => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    let filters: FilterT[] = [];
    if (savedFilters) {
      try {
        filters = JSON.parse(savedFilters);
        // Validate the loaded filters against the codec
        const result = FilterTArrayCodec.decode(filters);
        if (result._tag === "Left") {
          console.error(
            "Invalid filters loaded from local storage:",
            result.left
          );
          filters = filterArray.filter((filter) => filter?.isSelected);
        }
      } catch (error) {
        console.error("Error parsing filters from local storage:", error);
        filters = filterArray.filter((filter) => filter?.isSelected);
      }
    } else {
      filters = filterArray.filter((filter) => filter?.isSelected);
    }
    if (filters && filters.length > 0) {
      handleSearchRequest(filters, page);
    }
    if (!isInitial) {
      setCurrentPage(page);
    }
    // handleSearchRequest(filters, page);
  };

  const handleSearchRequest = async (filters: FilterT[], page = 0) => {
    const reqBody: { [key: string]: { condition?: string; value: any } } = {};
    filters.forEach((filter: FilterT) => {
      const field = filter.key;
      if (field)
        reqBody[field] = {
          condition: filter.condition,
          value: filter.values,
        };
    });

    if (!reqBody || Object.keys(reqBody).length == 0) return;
    companyMutation.mutate({
      filterObject: reqBody,
      page: page,
      pageSize: 20,
    });
    setBasicFilterIsOpen(false);
  };

  useEffect(() => {
    // if (hasFetched.current) return;
    // hasFetched.current = true;
    handleCurrentPageChange(0,true);
    // setBasicFilterIsOpen(false);

  }, []);
  return (
    <>
      {showFilter && (
        <>
          <TitleComponent className="fs-lg" marginTop="0px">
            Filters
          </TitleComponent>

          {/* <FilterComponent /> */}
          <FilterComponent
            isBasicFilterOpen={isBasicFilterOpen}
            setBasicFilterIsOpen={setBasicFilterIsOpen}
            handleSearchRequest={handleFilterSearch}
          />
        </>
      )}

      {/* // currentPage?: number;
      // setCurrentPage?: (val:number)=>void;
      // isPagination?: boolean;
      // companyData?: CompanyResultT;
      // onMount: UseQueryResult; */}
      <Company
        pageSize={20}
        currentPage={currentPage}
        setCurrentPage={handleCurrentPageChange}
        isPagination={true}
        companyData={companyData}
        companyMutation={companyMutation}
      />
    </>
  );
};

export default FundingRounds;